/**
 * Shared constants for the WYSIWYG editor
 */

/**
 * Available programming languages for code blocks
 */
export const PROGRAMMING_LANGUAGES = [
  'JavaScript',
  'TypeScript', 
  'Python',
  'Java',
  'C++',
  'C#',
  'Go',
  'Rust',
  'HTML',
  'CSS',
  'SQL',
  'Shell',
  'JSON',
  'YAML',
  'Markdown',
  'Plain Text'
] as const;

export type ProgrammingLanguage = typeof PROGRAMMING_LANGUAGES[number];